var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "AppModal",
    { attrs: { id: _vm.id, options: _vm.options, title: _vm.title } },
    [
      _vm.body
        ? _c("MarkdownContent", {
            staticClass: "markdown-content--typography",
            attrs: { content: _vm.body },
            on: {
              "custom-trigger": function($event) {
                return _vm.handleCustomTrigger($event)
              }
            }
          })
        : _c("LoadingCircle", { staticClass: "w-8 h-8 text-primary-700" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }